import { createRouter, createWebHistory } from 'vue-router'

// Modules
import { webRouter } from '@/modules/web/router'
import { backofficeRouter } from '@/modules/backoffice/router'

const router = createRouter({
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 }
  },
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [webRouter, backofficeRouter]
})

router.afterEach((to, from) => {
  window?.dataLayer?.push({ event: 'Page View', to: to.fullPath })
})

export default router
